module.exports = __webpack_public_path__ + "img/delete.48548740.svg";